var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wf-search-results-section" }, [
    _c("div", { staticClass: "wf-search-results-section-inner" }, [
      _vm.pages && _vm.pages.length > 0
        ? _c(
            "div",
            {
              staticClass:
                "\n        wf-search-results\n        wf-search-results-view-mode-swatch\n        wf-search-results-tile-size-small\n      "
            },
            [
              _vm._l(_vm.pages, function(item) {
                return _c("result-item", {
                  key: item.id,
                  attrs: {
                    className: "wf-search-result-scope-" + item.id,
                    imageUrl: item.imageUrl,
                    link: item.url,
                    title: _vm.$helpers.matchText(item.title, _vm.searchTerm),
                    date: item.date,
                    showViewButton: true
                  }
                })
              }),
              _vm._v(" "),
              _vm.totalPagesPages > _vm.pagesPageNumber ||
              (_vm.fetchingPages && _vm.pages.length === 0)
                ? _c("pc-load-more", { attrs: { loadMore: _vm.onLoadMore } })
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.pages.length === 0 && !_vm.fetchingPages
        ? _c("p", [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$resourceString["common.noResults"]) +
                "\n    "
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }